module.exports = __webpack_public_path__ + "img/IMG_8981_L_BlackMatted_MockedUp.52726793.jpg";